(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  function post(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    }).then(function () { window.location.reload(); });
  }
  function init() {
    var root = document.querySelector('[data-cart-lines]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-cart-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-line]');
        var current = parseInt(row.querySelector('span.w-9').textContent.trim(), 10) || 1;
        var next = Math.max(0, current + parseInt(b.dataset.delta, 10));
        post(parseInt(b.dataset.cartQty, 10), next);
      });
    });
    root.querySelectorAll('[data-cart-remove]').forEach(function (b) {
      b.addEventListener('click', function () { post(parseInt(b.dataset.cartRemove, 10), 0); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  function init(root) {
    var grid = root.querySelector('[data-plp-grid]');
    if (!grid || grid.dataset.plpReady) return;
    grid.dataset.plpReady = '1';

    var cards = [].slice.call(grid.querySelectorAll('.product-card'));
    var empty = root.querySelector('[data-plp-empty]');
    var state = { type: 'all', finish: 'all', sort: 'featured' };

    function label(n) { return n + ' ' + (n === 1 ? 'piece' : 'pieces'); }

    function apply() {
      var visible = cards.filter(function (c) {
        if (state.type !== 'all' && c.dataset.type !== state.type) return false;
        if (state.finish !== 'all' && c.dataset.finish !== state.finish) return false;
        return true;
      });
      cards.forEach(function (c) { c.hidden = visible.indexOf(c) === -1; });

      var sorted = visible.slice();
      if (state.sort === 'price-asc') sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (state.sort === 'price-desc') sorted.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else if (state.sort === 'newest') sorted.sort(function (a, b) { return (b.dataset.new === 'true') - (a.dataset.new === 'true'); });
      else sorted.sort(function (a, b) { return a.dataset.order - b.dataset.order; });
      sorted.forEach(function (c) { grid.appendChild(c); });

      root.querySelectorAll('[data-plp-count],[data-plp-count-mobile]').forEach(function (el) { el.textContent = label(visible.length); });
      var show = root.querySelector('[data-refine-show]');
      if (show) show.textContent = 'Show ' + visible.length + ' ' + (visible.length === 1 ? 'Piece' : 'Pieces');
      if (empty) empty.hidden = visible.length !== 0;
      grid.hidden = visible.length === 0;

      var filtered = state.type !== 'all' || state.finish !== 'all';
      root.querySelectorAll('[data-refine-dot]').forEach(function (d) { d.hidden = !filtered; });
      root.querySelectorAll('[data-refine-clear]').forEach(function (d) { d.hidden = !filtered; });
    }

    root.querySelectorAll('[data-facet]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.dataset.facet, value = btn.dataset.value;

        if (facet === 'finish' && state.finish === value && value !== 'all') value = 'all';
        state[facet] = value;
        root.querySelectorAll('[data-facet="' + facet + '"]').forEach(function (o) {
          var on = o.dataset.value === state[facet];
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    root.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.sort = btn.dataset.sortValue;
        root.querySelectorAll('[data-sort-value]').forEach(function (o) {
          var on = o.dataset.sortValue === state.sort;
          var tick = o.querySelector('[data-sort-tick]');
          if (tick) tick.hidden = !on;
          var li = o.closest('li');
          if (li) li.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var lbl = root.querySelector('[data-sort-label]');
        if (lbl) lbl.textContent = btn.textContent.trim();
        var list = root.querySelector('[data-sort-list]');
        var tog = root.querySelector('[data-sort-toggle]');
        if (list) list.hidden = true;
        if (tog) tog.setAttribute('aria-expanded', 'false');
        apply();
      });
    });

    var toggle = root.querySelector('[data-sort-toggle]');
    var list = root.querySelector('[data-sort-list]');
    if (toggle && list) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!list.hidden && !list.contains(e.target) && e.target !== toggle) {
          list.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { list.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      });
    }

    var drawer = root.querySelector('[data-refine-drawer]');
    if (drawer) {
      root.querySelectorAll('[data-refine-open]').forEach(function (b) {
        b.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
      });
      root.querySelectorAll('[data-refine-close]').forEach(function (b) {
        b.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; });
      });
    }
    root.querySelectorAll('[data-refine-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.type = 'all'; state.finish = 'all';
        root.querySelectorAll('[data-facet]').forEach(function (o) {
          var on = o.dataset.value === 'all';
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    apply();
  }

  function fillGrid(done) {
    var grid = document.querySelector('[data-plp-grid]');
    if (!grid) return done();
    var next = grid.getAttribute('data-next-page');
    if (!next) return done();
    fetch(next, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var more = doc.querySelector('[data-plp-grid]');
        if (!more) { grid.removeAttribute('data-next-page'); return done(); }
        var base = grid.querySelectorAll('.product-card').length;
        [].slice.call(more.querySelectorAll('.product-card')).forEach(function (c, i) {
          c.dataset.order = base + i;
          grid.appendChild(c);
        });
        var nn = more.getAttribute('data-next-page');
        if (nn) { grid.setAttribute('data-next-page', nn); fillGrid(done); }
        else { grid.removeAttribute('data-next-page'); done(); }
      })
      .catch(function () { done(); });
  }

  var TYPE_ORDER = ['Necklaces', 'Earrings', 'Bracelets', 'Rings'];
  function rank(list, v) { var i = list.indexOf(v); return i === -1 ? 99 : i; }

  function rebuildFacets() {
    var grid = document.querySelector('[data-plp-grid]');
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('.product-card'));

    function valuesFor(facet) {
      var vals = [];
      cards.forEach(function (c) {
        var v = c.dataset[facet];
        if (v && vals.indexOf(v) === -1) vals.push(v);
      });
      if (facet === 'type') vals.sort(function (a, b) { return rank(TYPE_ORDER, a) - rank(TYPE_ORDER, b); });
      else vals.sort(function (a, b) { return (a.indexOf('Gold') === -1) - (b.indexOf('Gold') === -1); });
      return vals;
    }

    function chip(facet, value, text, active) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lun-chip' + (active ? ' is-active' : '');
      b.dataset.facet = facet;
      b.dataset.value = value;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.textContent = text;
      return b;
    }

    function labelFor(facet, v) {
      if (facet !== 'finish') return v;
      return v.indexOf('Gold') !== -1 ? 'Gold' : v.indexOf('Silver') !== -1 ? 'Silver' : v;
    }

    var counts = {};
    ['type', 'finish'].forEach(function (facet) {
      var vals = valuesFor(facet);
      counts[facet] = vals.length;
      document.querySelectorAll('[data-facet-row="' + facet + '"]').forEach(function (row) {
        row.innerHTML = '';
        if (vals.length < 2) return;

        var wantsAll = facet === 'type' || row.closest('[data-refine-drawer]');
        if (wantsAll) row.appendChild(chip(facet, 'all', 'All', true));
        vals.forEach(function (v) { row.appendChild(chip(facet, v, labelFor(facet, v), false)); });
      });
    });

    document.querySelectorAll('[data-facet-divider]').forEach(function (d) {
      d.hidden = !(counts.type > 1 && counts.finish > 1);
    });
    ['type', 'finish'].forEach(function (facet) {
      document.querySelectorAll('[data-facet-group="' + facet + '"]').forEach(function (g) {
        g.hidden = counts[facet] < 2;
      });
    });
  }

  function boot() { fillGrid(function () { rebuildFacets(); init(document); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-faq]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-faq-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.dataset.faqTrigger;
        var panel = root.querySelector('[data-faq-panel="' + i + '"]');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-faq-trigger]').forEach(function (b) {
          var p = root.querySelector('[data-faq-panel="' + b.dataset.faqTrigger + '"]');
          b.setAttribute('aria-expanded', 'false');
          b.querySelector('[data-faq-q]').className = 'font-heading text-lg transition-colors duration-300 text-[#2c2e30]/80 group-hover:text-[#352274]';
          b.querySelector('[data-faq-icon]').className = 'w-8 h-8 flex items-center justify-center border transition-all duration-300 flex-shrink-0 ml-4 border-[#E8E2DA] text-[#a6808c] group-hover:border-[#352274]/30';
          if (p) p.className = 'overflow-hidden transition-all duration-500 max-h-0';
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('[data-faq-q]').className = 'font-heading text-lg transition-colors duration-300 text-[#352274]';
          btn.querySelector('[data-faq-icon]').className = 'w-8 h-8 flex items-center justify-center border transition-all duration-300 flex-shrink-0 ml-4 border-[#e6bd6b] text-[#e6bd6b] rotate-45';
          if (panel) panel.className = 'overflow-hidden transition-all duration-500 max-h-[500px] pb-6';
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-accordions]');
    if (root && !root.dataset.ready) {
      root.dataset.ready = '1';
      root.querySelectorAll('[data-acc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.acc;
          var panel = root.querySelector('[data-acc-panel="' + id + '"]');
          var open = panel.classList.contains('open');

          root.querySelectorAll('[data-acc-panel]').forEach(function (p) { p.classList.remove('open'); });
          root.querySelectorAll('[data-acc]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var s = b.querySelector('[data-acc-sign]');
            if (s) s.textContent = '+';
          });
          if (!open) {
            panel.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
            var sign = btn.querySelector('[data-acc-sign]');
            if (sign) sign.textContent = '−';
          }
        });
      });
    }

    var gal = document.querySelector('[data-gallery]');
    if (gal && !gal.dataset.ready) {
      gal.dataset.ready = '1';
      var main = gal.querySelector('[data-gallery-main]');
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) { main.src = t.dataset.galleryThumb; main.removeAttribute('srcset'); }
          gal.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
            o.classList.remove('ring-1', 'ring-[#352274]');
            o.classList.add('hover:ring-1', 'hover:ring-gold');
          });
          t.classList.remove('hover:ring-1', 'hover:ring-gold');
          t.classList.add('ring-1', 'ring-[#352274]');
        });
      });
    }

    var qty = document.querySelector('[data-qty-input]');
    if (qty && !qty.dataset.ready) {
      qty.dataset.ready = '1';
      var down = document.querySelector('[data-qty-down]');
      var up = document.querySelector('[data-qty-up]');
      if (down) down.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (up) up.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
